import { createContext, useMemo, useState } from "react";
import { Artifact, ArtifactTheme } from "../models/client";

interface ArtifactThemesContextValue {
  artifactThemes: ArtifactTheme[];
  setArtifactThemes: (artifactThemes: ArtifactTheme[]) => void;
}

export const ArtifactThemesContext = createContext<ArtifactThemesContextValue>(
  {} as ArtifactThemesContextValue
);

export const ArtifactsProvider: React.FC = ({ children }) => {
  const [artifactThemes, setArtifactThemes] = useState<ArtifactTheme[]>([]);

  const value = useMemo(
    () => ({ artifactThemes, setArtifactThemes }),
    [artifactThemes]
  );

  return (
    <ArtifactThemesContext.Provider value={value}>
      {children}
    </ArtifactThemesContext.Provider>
  );
};
